import { ActivityLogsList } from "#src/batteries-included-components/Layouts/ActivityLogs/ActivityLogsList";
import { FacilityUpdateStatusBanner } from "#src/routes/organization/facilities/[facilityId]/FacilityUpdateStatusBanner";
import { AssetType } from "@validereinc/domain";
import React from "react";

export const ChangeLogTab = ({ resourceId }: { resourceId: string }) => {
  return (
    <>
      <FacilityUpdateStatusBanner />
      <ActivityLogsList
        resourceId={resourceId}
        resourceType={{ name: AssetType.FACILITY }}
      />
    </>
  );
};
